export default __webpack_public_path__ + "static/media/volvo.7fd9f036.svg";